import { defineAttrs as e } from "../../utils/typed-attrs.js";
const t = e({
  type: { default: "unsupportedElement" },
  unsupportedTypeName: { default: "" },
  text: { default: "" }
}), r = {
  inline: !1,
  group: "block",
  attrs: t,
  parseDOM: [],
  toDOM(p) {
    return ["div"];
  }
};
export {
  r as unsupportedElementSpec
};
